import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
    header: {
        paddingBottom: "25px"
    },
    section: {
        marginBottom: "25px"
    }
}));

export default function Soporte(props) {
    const classes = useStyles();
    return (
        <>
            <Typography variant="h2" >
                Soporte
            </Typography>
            <Typography variant="body1" className={classes.section}>
                Nos interesa resolver su problema. Por favor, describa su problema y alguien de nuestro equipo de apoyo
                se pondrá en contacto rápidamente.
            </Typography>
            <div className={classes.header}>
                <TextField
                    fullWidth
                    id="outlined-multiline-static"
                    label="Descripción del problema"
                    multiline
                    rows={4}
                    defaultValue=""
                    variant="outlined"
                />
            </div>
            <Button variant="contained" color="secondary" className={classes.section}>
                Enviar problema
            </Button>
        </>
    );
}